import { useMutation } from '@apollo/client';
import { PATCH_NOTIFICATION_MUTATION } from '../../mutations';

export function usePatchNotificationMutation() {
    return useMutation( PATCH_NOTIFICATION_MUTATION );
}
